import {
  Component, ChangeDetectionStrategy, inject, NgZone,
  OnInit, OnDestroy, signal, input, computed,
} from '@angular/core';

@Component({
  selector: 'widget-countdown',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="countdown" [class.bitti]="bitti()">
      @if (bitti()) {
        <div class="bitti-yazi">Süre Doldu</div>
      } @else {
        <div class="birimler">
          @for (b of birimler(); track b.etiket) {
            <div class="birim">
              <span class="deger">{{ b.deger }}</span>
              <span class="etiket">{{ b.etiket }}</span>
            </div>
            @if (!$last) { <span class="ayirici">:</span> }
          }
        </div>
      }
    </div>
  `,
  styles: [`
    :host { display: block; }
    .countdown { text-align: center; font-family: 'SF Mono', Consolas, monospace; }
    .birimler { display: flex; align-items: center; justify-content: center; gap: 4px; }
    .birim { display: flex; flex-direction: column; align-items: center; min-width: 48px; }
    .deger { font-size: 2em; font-weight: 700; color: var(--py-metin, #e0e0e0); }
    .etiket { font-size: 0.65em; text-transform: uppercase; opacity: 0.5; color: var(--py-metin-ikincil, #aaa); }
    .ayirici { font-size: 1.8em; font-weight: 700; color: var(--py-metin, #e0e0e0); opacity: 0.4; align-self: flex-start; margin-top: 4px; }
    .bitti-yazi {
      font-size: 1.5em; font-weight: 700; color: #f5222d;
      animation: countdown-flash 0.6s ease-in-out infinite alternate;
    }
    @keyframes countdown-flash { from { opacity: 1; } to { opacity: 0.3; } }
  `],
})
export class CountdownComponent implements OnInit, OnDestroy {
  private zone = inject(NgZone);

  hedefTarih = input<string>('');

  kalanMs = signal(0);
  bitti = computed(() => this.kalanMs() <= 0 && !!this.hedefTarih());

  birimler = computed(() => {
    const ms = this.kalanMs();
    if (ms <= 0) return [];
    const toplam = Math.floor(ms / 1000);
    const gun = Math.floor(toplam / 86400);
    const saat = Math.floor((toplam % 86400) / 3600);
    const dk = Math.floor((toplam % 3600) / 60);
    const sn = toplam % 60;
    return [
      { deger: String(gun).padStart(2, '0'), etiket: 'Gün' },
      { deger: String(saat).padStart(2, '0'), etiket: 'Saat' },
      { deger: String(dk).padStart(2, '0'), etiket: 'Dakika' },
      { deger: String(sn).padStart(2, '0'), etiket: 'Saniye' },
    ];
  });

  private interval: any;

  ngOnInit() {
    this.hesapla();
    this.zone.runOutsideAngular(() => {
      this.interval = setInterval(() => this.hesapla(), 1000);
    });
  }

  private hesapla() {
    const hedef = this.hedefTarih();
    if (!hedef) { this.kalanMs.set(0); return; }
    this.kalanMs.set(Math.max(0, new Date(hedef).getTime() - Date.now()));
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }
}
